export default __webpack_public_path__ + "static/media/icon-comprador.07616a56.svg";